import { useState } from 'react';

const answers = [
  {
    category: 'About Us',
    q: 'What does Premier Hardwood Floors do?',
    a: 'Premier Hardwood Floors specializes in professional hardwood flooring services including installation, refinishing, repair, and replacement. We serve Maryland homeowners with expert craftsmanship designed to improve durability, appearance, and long-term property value.',
  },
  {
    category: 'Services',
    q: 'What hardwood flooring services are offered?',
    a: 'Services include custom hardwood floor installation, professional sanding and refinishing, seamless damage repair, and complete floor replacement. Each service is tailored to your floor\'s condition and your specific goals, with transparent pricing on every project.',
  },
  {
    category: 'Benefits',
    q: 'What are the benefits of professional hardwood flooring?',
    a: 'Professional hardwood flooring increases home resale value, improves aesthetics, eliminates allergens, and delivers decades of durability. Expert installation and refinishing ensure structural integrity, a flawless finish, and timeless beauty for any Maryland home.',
  },
  {
    category: 'Process',
    q: 'What is the hardwood flooring process?',
    a: 'The process starts with a free in-home estimate, followed by material and finish selection, subfloor preparation, precision installation or refinishing, and a final walkthrough to confirm your complete satisfaction before we consider the job done.',
  },
  {
    category: 'Comparison',
    q: 'Should I repair, refinish, or replace my hardwood floors?',
    a: 'Refinishing works best for structurally sound floors with surface wear — restoring beauty at 30–70% of replacement cost. Repair is ideal for localized damage like water stains or squeaks. Replacement is recommended when floors are too thin, structurally compromised, or you want a completely new look.',
  },
  {
    category: 'Comparison',
    q: 'Is refinishing worth it compared to installing new floors?',
    a: 'Refinishing is typically far more cost-effective than new installation and delivers equally stunning results on quality hardwood. It preserves the character of your original wood, extends lifespan by 10–15 years, and avoids the disruption of full tear-out and disposal. Most Maryland homeowners choose refinishing first.',
  },
];

const categoryColors: Record<string, string> = {
  'About Us': 'bg-walnut/10 text-walnut',
  'Services': 'bg-oak/10 text-oak',
  'Benefits': 'bg-gold/15 text-amber-700',
  'Process': 'bg-green-50 text-green-700',
  'Comparison': 'bg-sky-50 text-sky-700',
};

export default function AIAnswers() {
  const [active, setActive] = useState<number | null>(0);

  return (
    <section className="bg-sand py-28 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-walnut/10 rounded-full px-4 py-1.5 mb-5">
            <i className="ri-robot-line text-walnut text-sm" />
            <span className="font-sans text-xs text-walnut font-semibold uppercase tracking-wide">AI &amp; Voice Search Optimized</span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl text-walnut font-bold mt-1">
            Common Questions, Answered
          </h2>
          <p className="font-sans text-charcoal/55 mt-5 text-base max-w-lg mx-auto">
            Everything you need to know about Maryland hardwood flooring — including repair vs. refinish comparisons.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5">
          {answers.map((item, idx) => (
            <button
              key={idx}
              onClick={() => setActive(active === idx ? null : idx)}
              className={`text-left rounded-2xl p-7 border transition-all duration-200 cursor-pointer group ${
                active === idx
                  ? 'bg-walnut border-walnut'
                  : 'bg-white border-sand-dark hover:border-oak/30'
              }`}
            >
              <div className="flex items-start gap-4">
                <div className={`flex-shrink-0 mt-0.5 px-2.5 py-1 rounded-full text-xs font-semibold font-sans whitespace-nowrap ${
                  active === idx ? 'bg-white/15 text-white' : (categoryColors[item.category] || 'bg-gold/10 text-walnut')
                }`}>
                  {item.category}
                </div>
                <div className="flex-1 min-w-0">
                  <p className={`font-sans text-base font-bold leading-snug mb-3 ${active === idx ? 'text-white' : 'text-walnut'}`}>
                    {item.q}
                  </p>
                  <p className={`font-sans text-sm leading-relaxed transition-all ${
                    active === idx ? 'text-white/80 block' : 'text-charcoal/60 line-clamp-2'
                  }`}>
                    {item.a}
                  </p>
                  <div className={`mt-3 flex items-center gap-1 text-xs font-medium font-sans ${active === idx ? 'text-gold' : 'text-oak'}`}>
                    {active === idx ? 'Show less' : 'Read full answer'}
                    <i className={`ri-arrow-${active === idx ? 'up' : 'down'}-s-line`} />
                  </div>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
